import apiClient from '../../../Services/ApiClient';
import { User } from '../../../graphql/graphql';
import { UserEditedMeta } from '../../../Components/PatientProfile/PatientProfileParts/PatientProfileInformation';
import { isArray } from 'lodash';
import { MetaKey } from '../../Meta/Enums/MetaKey.enum';

export const saveToUserMeta = async ({
	userId,
	key,
	value,
	workplaceId,
}: {
	userId: string;
	key: string;
	value: any;
	workplaceId?: string;
}) => {
	await apiClient.post(`/user/${userId}/meta/`, {
		key,
		value,
		workplaceId,
	});
};

export const isMappedMeta = (
	item: User | UserEditedMeta | null,
): item is UserEditedMeta => !isArray(item?.meta);

export const getUsersTAJ = (
	user: User | UserEditedMeta | null,
): string | undefined => {
	return isMappedMeta(user)
		? user?.meta?.taj
		: user?.meta?.find(item => item?.key === MetaKey.TAJ)?.value;
};

export const getUsersMothersFullname = (
	user: User | UserEditedMeta | null,
): string | undefined => {
	return isMappedMeta(user)
		? user?.meta?.mothersFullname
		: user?.meta?.find(item => item?.key === MetaKey.MOTHERS_FULLNAME)?.value;
};

export const getUsersBirthPlace = (
	user: User | UserEditedMeta | null,
): string | undefined => {
	return isMappedMeta(user)
		? user?.meta?.birthPlace
		: user?.meta?.find(item => item?.key === MetaKey.BIRTH_PLACE)?.value;
};

export const getUsersPESEL = (
	user: User | UserEditedMeta | null,
): string | undefined => {
	return isMappedMeta(user)
		? user?.meta?.pesel
		: user?.meta?.find(item => item?.key === MetaKey.PESEL)?.value;
};

export const getUsersEMSO = (
	user: User | UserEditedMeta | null,
): string | undefined => {
	return isMappedMeta(user)
		? user?.meta?.emso
		: user?.meta?.find(item => item?.key === MetaKey.EMSO)?.value;
};

export const getUsersJMBG = (
	user: User | UserEditedMeta | null,
): string | undefined => {
	return isMappedMeta(user)
		? user?.meta?.jmbg
		: user?.meta?.find(item => item?.key === MetaKey.JMBG)?.value;
};
